import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle.jsx';

const ComputerMenu = () => {

	const { t } = useTranslation();

	return (

		<div id="ComputerMenu1" className="page1 paddingTop50">
			<div className="wrapper">
				<PageTitle>
					<h1>{t('Levels')}</h1>
				</PageTitle>
				<ul className="buttonList">
					<li>
						<a href="#Game/Classic/Easy" className="button buttonEasy">
							{t('Easy')}
						</a>
					</li>
					<li>
						<a href="#Game/Classic/Medium" className="button buttonMedium">
							{t('Medium')}
						</a>
					</li>
					<li>
						<a href="#Game/Classic/Hard" className="button buttonHard">
							{t('Hard')}
						</a>
					</li>
					<li>
						<a href="#Game/Classic/CrazyNinja" className="button buttonCrazyNinja">
							{t('Crazy Ninja')}
						</a>
					</li>

				</ul>

			</div>
		</div>
	);
};

export default React.memo(ComputerMenu);
